import React, { useState } from 'react';
import HeroSlideshow from './PresentacionPortada';
import styles from './Portada.module.css';
import logoWebp from '../../recursos/imagenes/logo.webp';

export const HeroSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    { image: '/imagenes/proyectos/otros_limpieza_de_tuberia_34.webp' }, // Técnico con impermeable amarillo real
    { image: '/imagenes/proyectos/otros_proyectos_1_62.webp' },
    { image: '/imagenes/historia/seima-limpieza-tuberia.webp' },
    { image: '/imagenes/historia/seima-camioneta-frente.webp' },
    { image: '/imagenes/historia/seima-lavadoras-instaladas.webp' },
    { image: '/imagenes/proyectos/otros_limpieza_tuberias_1_39.webp' },
    { image: '/imagenes/proyectos/lavanderia_lavadora_de_ropa_60_libras_17.webp' },
    { image: '/imagenes/proyectos/hidrolavadoras_hidrolavadoras_2_11.webp' }
  ];

  const handleScrollTo = (id) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className={styles.heroSection} id="home">
      <div className={styles.heroGrid}>
        {/* Left Section - Text and Logo */}
        <div className={styles.leftSide}>
          {/* Animated background lights */}
          <div className={styles.light1}></div>
          <div className={styles.light2}></div>
          
          <div className={styles.content}>
            <img src={logoWebp} alt="SEIMA S.A." className={styles.heroLogo} />
            <h1 className={styles.title}>SUMINISTROS DE EQUIPO INDUSTRIAL Y MANTENIMIENTO</h1>
            <div className={styles.divider}></div>
            <p className={styles.subtitle}>
              Ayudamos a mejorar los tiempos de rendimiento operativos con lavadoras, secadoras tipo industriales y mantenimiento preventivo.
            </p>
            
            <div className={styles.btnGroup}>
              <button 
                onClick={() => handleScrollTo('#services')} 
                className="btn btn-primary"
              >
                Conoce más
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="18" height="18" style={{marginLeft: '8px'}}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </button>
              <button 
                onClick={() => handleScrollTo('#contact')} 
                className={`btn btn-secondary ${styles.btnSecondaryOverride}`}
              >
                Realiza una Cotización
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="18" height="18" style={{marginLeft: '8px'}}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Right Section - Visual Resource (Slideshow) */}
        <div className={styles.rightSide}>
          <HeroSlideshow 
            slides={slides} 
            activeIndex={activeIndex} 
            setActiveIndex={setActiveIndex} 
          />
        </div>
      </div>

      {/* Visual Scroll Down Indicator */}
      <div className={styles.scrollDown} onClick={() => handleScrollTo('#about')}>
        <span className={styles.mouse}>
          <span className={styles.wheel}></span>
        </span>
        <span className={styles.arrowScroll}></span>
      </div>
    </section>
  );
};
export default HeroSection;
